import React from 'react';
import { Link } from 'react-router-dom';
import { usePermissions } from '../../../Services/PermissionsContext'; // Import the permissions context
import { hasPermission } from '../../../Services/checkPermissions';   // Import the helper function

const TabMenu = ({ name }) => {
    const permissions = usePermissions(); // Get global permissions
    if (permissions.length === 0) {
        return <div>No permissions available</div>; // Handle case when there are no permissions
    }

    return (
        <div className='management-tabs'>
            <ul className='management-tablinks'>
               {hasPermission(permissions, 'pending-orders', 'view') && 
                    <li className={`action-item ${name === 'pending-orders' ? 'active-tab' : ''}`}>
                        <Link to="/admin/laboratory/pending-orders">Pending Orders</Link>
                    </li>
                }
                {hasPermission(permissions, 'order-history', 'view') && 
                <li className={`action-item ${name === 'order-history' ? 'active-tab' : ''}`}>
                    <Link to="/admin/laboratory/order-history">Order History</Link>
                </li>
                }

            </ul>
        </div>
    );
};

export default TabMenu;
